import React from "react";
import "./Gymify_Animation.css";

const Gymify_Animation = () => {
  return (
    <section className="gymify_animation">
      <div className="container">
        <div className="main_content_div">
          {/* Left Side */}
          <div className="side_content left_content">
            <img
              src="/Assets/images/logo/mobile-1.png"
              alt="User App"
              className="phone_mockup"
            />
            <div className="text_block left_block">
              <h3>For Goers</h3>
              <p>
                Finding the right gym shouldn’t be a workout in itself. Gymify
                puts the best fitness centers in your pocket!
              </p>
            </div>
          </div>

          {/* Middle */}
          <div className="middle_logo_area">
            <div className="logo_image_holder">
              <img
                src="/Assets/images/logo/gymify.png"
                alt="logo"
                className="gymify_logo"
              />
              <img
                src="/Assets/images/logo/gymify-2.png"
                alt="logo"
                className="hallow_logo"
              />
            </div>
          </div>

          {/* Right Side */}
          <div className="side_content right_content">
            <div className="text_block right_block">
              <h3>For Owners</h3>
              <p>
                Manage your facility, track your revenue, and reach new members
                with comprehensive vendor dashboard.
              </p>
            </div>
            <img
              src="/Assets/images/logo/mobile-2.png"
              alt="Owner App"
              className="phone_mockup"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gymify_Animation;
